export default function Location() {
  return (
    <section id="location" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-3xl overflow-hidden shadow-xl mb-16 h-[450px]">
          <iframe
            src="https://maps.google.com/maps?q=%E6%9D%B1%E4%BA%AC%E9%83%BD%E8%B6%B3%E7%AB%8B%E5%8C%BA%E6%9D%B1%E4%BC%8A%E8%88%881%E4%B8%81%E7%9B%AE13&t=&z=17&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="RAMEN鶴 店舗地図"
          ></iframe>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-10 -mt-8 relative z-10 max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="text-center md:text-left">
              <div className="w-12 h-12 flex items-center justify-center mb-4 mx-auto md:mx-0">
                <i className="ri-map-pin-line text-3xl text-red-800"></i>
              </div>
              <p className="text-xs text-gray-500 mb-2 tracking-wide">住所</p>
              <p className="text-gray-900 leading-relaxed">
                東京都足立区東伊興<br />
                1丁目13<br />
                コーポワタイ
              </p>
            </div>

            <div className="text-center md:text-left">
              <div className="w-12 h-12 flex items-center justify-center mb-4 mx-auto md:mx-0">
                <i className="ri-time-line text-3xl text-red-800"></i>
              </div>
              <p className="text-xs text-gray-500 mb-2 tracking-wide">営業時間</p>
              <p className="text-gray-900 leading-relaxed">
                平日：11:00〜15:00、17:00〜22:30<br />
                週末・祝日：11:00〜22:30<br />
                <span className="text-red-600 font-semibold">定休日：月曜</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
